
import { Component, PropSync, Mixins, Watch } from "vue-property-decorator";
import DateRangeCustomOrPredefined from "@/components/Base/DateRange/DateRangeCustomOrPredefined.vue";
import ComboboxSingleSelectBasic from "@/components/Base/Inputs/Combobox/ComboboxSingleSelectBasic.vue";
import OrderStatus from "@/enumerations/Common/OrderStatus";
import { BookingFilter } from "@/interfaces/Contracts/BookingFilter";
import ComboboxObject from "@/interfaces/Base/Combobox/ComboboxObject";
import DateRangeCustom from "@/components/Base/DateRange/DateRangeCustom.vue";
import { PredefinedDateRangeType } from "@/enumerations/Dates/DateRangePredefined/PredefinedDateRangeType";

@Component({
  components: {
    DateRangeCustomOrPredefined,
    ComboboxSingleSelectBasic,
    DateRangeCustom,
  },
})
export default class ViewBookingsFilter extends Mixins() {
  @PropSync("filter")
  filterSync!: BookingFilter;

  includeAllDatesOption = true;
  orderStatusList: ComboboxObject[] = new OrderStatus().GetComboboxObjects();

  @Watch("filterSync.status")
  statusChanged() {
    this.includeAllDatesOption =
      this.filterSync.status === OrderStatus.open.value;

    if (
      !this.includeAllDatesOption &&
      this.filterSync.effectiveDateSelection.predefinedDateRangeTypeValue ===
        PredefinedDateRangeType.AllDates
    ) {
      this.filterSync.effectiveDateSelection.predefinedDateRangeTypeValue =
        PredefinedDateRangeType.OneYear;
    }
  }
}
